document.addEventListener('DOMContentLoaded', () => {
  const accordionButtons = document.querySelectorAll('.deakin-accordion__section button');
  //ensure the page contains the node
  if (accordionButtons.length) {
    const accordionDivs = document.querySelectorAll('.deakin-accordion__section--content');
    const accordionIcons = document.querySelectorAll('.deakin-accordion__section button span:nth-of-type(2)');

    const accordionSections = document.querySelectorAll('.deakin-accordion__section');
    //ensure the number of tab buttons matches the amount of content divs
    if (accordionButtons.length === accordionDivs.length) {
      //add an eventlistener on each of the buttons to add the isActive class
      Object.values(accordionButtons).forEach((button, index) => {
        button.addEventListener('click', () => {
          if (accordionButtons[index].classList.contains('deakin-accordion__buttonClicked')) {
            accordionIcons[index].classList.remove('deakin-accordion__clickedIcon', 'deakin-accordion--button-close');
            accordionButtons[index].classList.remove('deakin-accordion__buttonClicked');
            accordionDivs[index].classList.remove('deakin-accordion__showContent');
            accordionSections[index].classList.remove('deakin-accordion__addLeftBorder');
            accordionDivs[index].style.maxHeight = '0px';
            button.setAttribute('aria-expanded', false);
            accordionDivs[index].setAttribute('aria-hidden', true);
          } else {
            accordionIcons[index].classList.add('deakin-accordion__clickedIcon', 'deakin-accordion--button-close');
            accordionButtons[index].classList.add('deakin-accordion__buttonClicked');
            accordionDivs[index].classList.add('deakin-accordion__showContent');
            accordionDivs[index].style.maxHeight = accordionDivs[index].scrollHeight + 'px';
            accordionSections[index].classList.add('deakin-accordion__addLeftBorder');
            button.setAttribute('aria-expanded', true);
            accordionDivs[index].setAttribute('aria-hidden', false);
          }
        });
      });
    }
  }
  const firstAccordionOpen = document.querySelectorAll('.deakin-accordion__firstAccordionOpen');
  if (firstAccordionOpen.length) {
    setTimeout(function () {
      firstAccordionOpen.forEach((acc) => {
        acc.click();
      });
    }, 100);
  }

  const noHeadingAccordion = document.querySelectorAll('.deakin-accordion--no-heading');
  if (noHeadingAccordion.length) {
    noHeadingAccordion[0].style.marginTop = '25px';
  }
});
